const FIRST_WORKPLAN_YEAR = 2025;
const FUTURE_PLANNING_YEARS = 5;

export function getWorkplanYears(currentYear = new Date().getFullYear()) {
  const lastYear = Math.max(FIRST_WORKPLAN_YEAR, currentYear) + FUTURE_PLANNING_YEARS;

  return Array.from(
    { length: lastYear - FIRST_WORKPLAN_YEAR + 1 },
    (_, index) => FIRST_WORKPLAN_YEAR + index
  );
}
